import { computed } from 'vue'

import { useCartActions } from '~/composables/useCartActions'
import { useLogger } from '~/composables/useLogger'
import { useCartStore } from '~/stores/useCartStore'

/** The saved draft orders and the actions that continue or remove one. */
export function useDraftOrders() {
  const cartStore = useCartStore()
  const cartActions = useCartActions()
  const logger = useLogger('DraftOrdersView')

  const continueOrder = (storeSlug: string) => {
    cartActions.continueOrder(storeSlug).catch((error: unknown) => {
      logger.error('continueOrder', { error })
    })
  }

  const removeDraft = async (storeSlug: string) => {
    await cartActions.removeDraft(storeSlug)
  }

  return { continueOrder, draftOrders: computed(() => cartStore.draftOrders), removeDraft }
}
